import Path from "../../services/paths";
import UploadXlxActions from "../actions/uploadDPXlxActions";
import utils from "../common/utils";
import axios from "axios";

import {getCookie} from '../../util-functions/util-funtions'
import CustomToast from '../../util-functions/customToast.jsx'
class UploadDPXlxMiddleware {
  static uploadXlx(
    data1
  ) {
    let DemandPlannerVersion=new FormData()
    DemandPlannerVersion.append("Upload",data1)
    // let DemandPlannerVersion={Upload:data1}
    let url = Path.POST_UPLOAD_DP_XLX;
    var csrftoken = getCookie('csrftoken');
    // if (Array.isArray(selectedCategory)) {
    //   selectedCategory.forEach(element => {
    //     url += `category=${element}&`;
    //   });
    // }
    // if (Array.isArray(selectedBrand)) {
    //   selectedBrand.forEach(element => {
    //     url += `brand=${element}&`;
    //   });
    // }
    // if (Array.isArray(selectedSku)) {
    //   selectedSku.forEach(element => {
    //     url += `master_sku=${element}&`;
    //   });
    // }
    // if (Array.isArray(selectedRegion)) {
    //   selectedRegion.forEach(element => {
    //     url += `region=${element}&`;
    //   });
    // }
    // if (Array.isArray(selectedDemandDriver)) {
    //   selectedDemandDriver.forEach(element => {
    //     url += `demmand_driver_type=${element}&`;
    //   });
    // }
    // if (isValue) {
    //   url += `is_value=${isValue}&`;
    // } else {
    //   url += `is_value=${isValue}&`;
    // }

    // url = url.slice(0, -1);

    return dispatch => {
      dispatch(UploadXlxActions.uploadXlxRequest());

      utils
        .get_token()
        .then(token => {
          axios({
            method: "POST",
            url: url,
            data:DemandPlannerVersion,
            // responseType: 'blob',
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`,
              'X-CSRFToken': csrftoken
            },
          })
            .then(res => {
              if (res.error) {
              CustomToast('error', 'File Upload Failed!')
              } else {
                CustomToast('success', 'File Uploaded Successfully!')
                dispatch(UploadXlxActions.uploadXlxSuccessul(res));
              }
            })
            .catch(error => {
              CustomToast('error', 'File Upload Failed!')
              dispatch(UploadXlxActions.uploadXlxFailed(error));
            });
        })
        .catch(error => {
          dispatch(UploadXlxActions.uploadXlxFailed(error));
        });
    };
  }
}

export default UploadDPXlxMiddleware;
